
export default {
  namespace: 'wamp',
  auto_reestablish: true,
  auto_close_timeout: -1,
};
